export default "__VITE_PUBLIC_ASSET__499b221b__"